import {Injectable} from "@angular/core";
import {ResetPasswordUseCase} from "@app/core/user/application/reset-password.use-case";
import {PopupNotifier} from "@app/presentation/components/errors/popup.notifier";
import {BehaviorSubject, firstValueFrom} from "rxjs";
import {RecaptchaAction, RecaptchaService} from "@app/presentation/services/recaptcha/recaptcha.service";

@Injectable({
    providedIn: 'root',
})
export class ResetPasswordViewModel {
    public notifier = new PopupNotifier();
    public passwordReset$ = new BehaviorSubject<boolean>(false)
    public loading$ = new BehaviorSubject<boolean>(false)
    constructor(
        private resetPasswordUseCase: ResetPasswordUseCase,
        private recaptchaService: RecaptchaService
    ) { }

    public async resetPassword(email: string) {
        this.loading$.next(true);
        
        const token = await firstValueFrom(this.recaptchaService.getToken(RecaptchaAction.LOGIN));
        this.resetPasswordUseCase.execute(email,token).subscribe({
            next: response => {
                this.passwordReset$.next(true);
                this.loading$.next(false);
            }, 
            error: error => {
                this.loading$.next(false);
                this.notifier.notifyError(error)
            }
        });
    }
}

